import React, { useEffect } from 'react';
import * as R from "ramda";
import $ from 'jquery';
import { AssuranceOptions, AssuranceOptionsBO, CommonServices, ConnectionTypes, convertConnectionTypesToServiceType, OtherService, PersonalServices, SocialNetworksOptions } from '../../../../constants/utils/connectionTypes';
import { useDispatch } from 'react-redux';
import { fetchServices, resetServices } from '../../../../actions/backoffice/configuration';
import { Link, useHistory } from 'react-router-dom';



export const ServiceTableFilter = ({ filters, setFilters, setPageSearch, pageSearch, configState, serviceType, routerQuery, allServices }) => {

    const dispatch = useDispatch();
    const history = useHistory();
    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {

        const filterForm = document.querySelector("#filterForm");
        const handleClick = (e) => {
            if (e.target.type === "button") {
                e.target.parentElement.classList.remove("show");
            }


        };
        filterForm.addEventListener("click", handleClick);

        return () => filterForm.removeEventListener("click", handleClick);
    }, []);



    const socialNetwork = {
        EN: "SocialNetwork",
        FR: convertConnectionTypesToServiceType("SocialNetwork")
    };


    return (
        <nav className="navbar navbar-expand-sm navbar-light px-0 mb-xl-2 mt-sm mt-xl-0">
            <button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
                <span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
            </button>
            <div className="collapse navbar-collapse flex-column" id="navbarNav">
                <form className="form-inline w-xl-75 container-default mx-auto justify-content-center" id="filterForm" onSubmit={(e) => e.preventDefault()}>
                    <div className={"my-1 input-group btn-dim rounded-max btn-alert" + (routerQuery.serviceType === "" ? "" : " active")} role="button">
                        <p className="form-control bg-none border-none rounded-inherit my-auto small" id="typeDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{configState.serviceType === "" ? "Choisir un type de service" : serviceType?.title.toUpperCase()}</p>
                        <div className="input-group-prepend rounded-inherit dropdown">
                            <button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="typeDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="eva eva-radio-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="typeDropdown">
                                {/* <button className={"dropdown-item py-2 h6 mb-0 " + (filters.status === undefined ? "active" : "")} type="button" onClick={() => setFilters({ ...filters, status: undefined })}>Tous le type</button>
                                <button className={"dropdown-item py-2 h6 mb-0 " + (filters.status === "type1" ? "active" : "")} type="button" onClick={() => setFilters({ ...filters, status: "type1" })}>Type 1</button>
                                <button className={"dropdown-item py-2 h6 mb-0 " + (filters.status === "type2" ? "active" : "")} type="button" onClick={() => setFilters({ ...filters, status: "type2" })}>Type 2</button>
                                <button className={"dropdown-item py-2 h6 mb-0 " + (filters.status === "type3" ? "active" : "")} type="button" onClick={() => setFilters({ ...filters, status: "type3" })}>Type 3</button>
                                <button className={"dropdown-item py-2 h6 mb-0 " + (filters.status === "type4" ? "active" : "")} type="button" onClick={() => setFilters({ ...filters, status: "type4" })}>Type 4</button>
                                <button className={"dropdown-item py-2 h6 mb-0 " + (filters.status === "type5" ? "active" : "")} type="button" onClick={() => setFilters({ ...filters, status: "type5" })}>Type 5</button> */}
                                <button className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.serviceType === "" ? "active" : "")} type="button" onClick={() => {
                                    /* setFilters({ ...filters, status: undefined }); */
                                    dispatch(resetServices());
                                    history.push(`/backoffice/configuration/services`);
                                }}>Choisir le type...</button>

                                {
                                    R.sortWith([R.ascend(R.prop('normalizedTitle'))])(allServices).map((srv, index) => {

                                        return (<Link to={`/backoffice/configuration/services?page=1&serviceType=${srv.connectionType}&sortBy=OrganizationName&sortDesc=false`} key={srv.connectionType + index} className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.serviceType === srv.connectionType ? "active" : "")} type="button" >{srv.title.toUpperCase()}</Link>);
                                    })
                                }

                            </div>
                        </div>
                    </div>
                    <div className={"my-1 input-group btn-dim rounded-max ml-auto ml-md-2 flex-grow-1" + (pageSearch !== "" ? " active" : "")}>
                        <input type="text" className="form-control bg-none rounded-inherit border-none no-focus shadow-none" placeholder="Recherche" aria-label="Recherche" value={pageSearch} onChange={(e) => setPageSearch(e.target.value)} />
                        <div className="input-group-prepend rounded-inherit">
                            <button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4"><i className="eva eva-search-outline align-middle fs-root lh-0 o-70 o-100--hover"></i></button>
                        </div>
                    </div>
                    <div className="divider-vertical mx-3"></div>
                    <button type="button" className="btn btn-white-primary rounded-max p-0 mr-2" data-toggle="modal" data-target="#serviceModal">
                        <p className="form-control my-auto small">Ajouter plus de services</p>
                        <div className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4">
                            <i className="eva eva-plus-outline align-middle fs-root lh-xs"></i>
                        </div>
                    </button>
                </form>
            </div>
        </nav>
    );
};

